module.exports = __webpack_public_path__ + "static/media/homepage.9a2161b7.svg";